import { SvgIcon, SvgIconProps } from "@mui/material";

const createIcon = (
  path: string,
  stroke: string,
  strokeWidth: string,
  viewBox: string
) =>
  function Icon(props: SvgIconProps) {
    return (
      <SvgIcon viewBox={viewBox} sx={{ fontSize: 20, ...props.sx }} {...props}>
        <path d={path} stroke={stroke} strokeWidth={strokeWidth} fill="none" strokeLinecap="round" strokeLinejoin="round" />
      </SvgIcon>
    );
  };

export default createIcon;
